module.exports = __webpack_public_path__ + "static/media/clock.7838e330.svg";